export interface Environment {
  root_api: string;
  keycloak_url: string;
  keycloak_realm: string;
  keycloak_client_id: string;
}

declare global {
  interface Window {
    environment: Environment;
  }
}

function validateEnv(raw: Environment | undefined): Environment {
  if (!raw) {
    throw new Error(
      "[config] window.environment is not defined — copy public/env.js.example to public/env.js and fill it in",
    );
  }

  for (const key of [
    "root_api",
    "keycloak_url",
    "keycloak_realm",
    "keycloak_client_id",
  ] as const) {
    if (!raw[key]) {
      throw new Error(
        `[config] window.environment.${key} is not set — see public/env.js`,
      );
    }
  }

  return raw;
}

export const env: Environment = validateEnv(window.environment);
